import React, { useEffect } from 'react';
import { Image as AntdImage } from 'antd';
import * as fileApi from '@/api/file';
interface ImageViewerProps {
    filePath: string;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ filePath }) => {

    const [uri, setUri] = React.useState<string>();

    useEffect(() => {
        const setUriHandler = async () => {
            const data = await fileApi.getRawFileResourceInBlob(filePath);
            if (data) {
                const url = window.URL.createObjectURL(data);
                setUri(url);
            }
        }
        setUriHandler()
    }, [filePath]);

    const wrapperRef = React.useRef<HTMLDivElement>(null);

    const [height, setHeight] = React.useState<number>(0);
    const [width, setWidth] = React.useState<number>(0);
    const [aspectRatio, setAspectRatio] = React.useState<number>(1);

    useEffect(() => {
        const img = new window.Image();
        img.src = uri ?? '';
        img.onload = () => {
            setAspectRatio(img.naturalWidth / img.naturalHeight);
        };
    }, [uri]);

    useEffect(() => {
        const updateDimensions = () => {
            const wrapperHeight = wrapperRef.current?.offsetHeight ?? 0;
            const wrapperWidth = wrapperRef.current?.offsetWidth ?? 0;
            if (wrapperWidth / aspectRatio <= wrapperHeight) {
                setWidth(wrapperWidth);
                setHeight(wrapperWidth / aspectRatio);
            } else {
                setHeight(wrapperHeight);
                setWidth(wrapperHeight * aspectRatio);
            }
        };
        updateDimensions();

        const resizeObserver = new ResizeObserver(() => {
            updateDimensions();
        });

        if (wrapperRef.current) {
            resizeObserver.observe(wrapperRef.current);
        }

        return () => {
            if (wrapperRef.current) {
                resizeObserver.unobserve(wrapperRef.current);
            }
        };
    }, [aspectRatio, wrapperRef]);

    return <div ref={wrapperRef} className='w-full h-full flex justify-center items-center'>
        <AntdImage src={uri} height={height} width={width} preview={{ getContainer: wrapperRef?.current ?? undefined }} />
    </div>;
};

export default ImageViewer;